import {useMutation, useQuery} from 'react-query';
import {createConversation, getConversation} from '../../api/conversation';

export function useGetConversation({userId} = {}, queryConfig = {}) {
    return useQuery(['GET_ALL_CONVERSATION'], () => getConversation(userId), queryConfig)
}

export function useCreateConversation({queryConfig={}} = {}) {
    return useMutation(createConversation, queryConfig)
}